import { initTracing } from './tracing'
import { initSessionReplay } from './session-replay'

let initialized = false

export function initObservability() {
  if (initialized) return
  initialized = true

  // Initialize OpenTelemetry tracing
  initTracing()

  // Initialize OpenReplay session replay
  initSessionReplay()
}

export { setSessionUser } from './session-replay'
